<template>
  <v-dialog
    v-if="$vuetify.breakpoint.smAndDown"
    v-model="visibility"
    fullscreen
    hide-overlay
    transition="fade-transition"
    eager
    persistent
  >
    <transition name="scroll-x-reverse-transition" appear>
      <div v-show="visibility" class="mobile-menu" :style="width">
        <slot />
        <div style="height:54px" />
      </div>
    </transition>
  </v-dialog>
</template>
<script>
export default {
  name: "AppMobileMenu",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    width: {
      type: String,
      default: ""
    }
  },
  computed: {
    visibility: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    $route() {
      this.visibility = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.mobile-menu {
  width: 320px;
  background: var(--v-strong-base);
  z-index: 10;
  position: absolute;
  height: 100%;
  overflow-y: auto !important;
  overflow-x: hidden;
}
</style>
